import { createModule } from '@soltalabs/stateless'
import { SiteModule } from 'modules/ravensdown/site'
import {
  head,
  prop,
  path,
  map,
  isNotNilOrEmpty,
  isNilOrEmpty,
} from '@soltalabs/ramda-extra'

const INITIAL_STATE = Object.freeze({
  forecastTime: undefined,
  forecastStartTimes: [],
})

const updateForecastTime = (module) => (_, forecastTime) => {
  module.setState({ forecastTime })
}

const ForecastModule = createModule({
  name: 'forecast',
  initialState: INITIAL_STATE,
  decorators: {
    updateForecastTime,
  },
})

SiteModule.subscribe((state) => {
  const { entities, order } = state

  if (isNilOrEmpty(order)) {
    return
  }

  const arbitrarilySelectedSite = prop(head(order))(entities)
  const forecastTime = path(['assessments', 0, 'assessmentValidityPeriodStart'])(
    arbitrarilySelectedSite
  )

  const siteList = order.map((id) => prop(id)(entities))
  const sitesWithAssessments = siteList.filter(
    ({ assessments }) => isNotNilOrEmpty(assessments) && assessments.length === 72
  )
  const assessments = path([0, 'assessments'])(sitesWithAssessments)
  const forecastStartTimes = map(prop('assessmentValidityPeriodStart'))(assessments)

  ForecastModule.setState({
    forecastTime,
    forecastStartTimes,
  })
})

export { ForecastModule }
